import mutationTypes from './mutation-types';

export default {
  /**
   * 设置顶部导航栏
   */
  [mutationTypes.SET_NAV_TOP_MENU](state, navTopMenu) {
    state.navTopMenu = navTopMenu;
  },

  /**
   * 设置左侧导航栏
   */
  [mutationTypes.SET_NAV_LEFT_MENU](state, navLeftMenu) {
    sessionStorage.setItem('navLeftMenu', JSON.stringify(navLeftMenu));
    state.navLeftMenu = navLeftMenu;
  },

  /**
   * 设置region
   */
  [mutationTypes.SET_REGION](state, region) {
    sessionStorage.setItem('ai-region-list', JSON.stringify(region));
    state.region = region;
  },

  /**
   * 设置被选中region
   */
  [mutationTypes.SET_SELECTED_REGION_ID](state, selectedRegionId) {
    if (selectedRegionId) {
      localStorage.setItem('ai-select-region', selectedRegionId);
      state.selectedRegionId = selectedRegionId;
      window.location.reload();
    } else if (localStorage.getItem('ai-select-region')) {
      let setRegionId;
      let localStorageRegionId = localStorage.getItem('ai-select-region');
      // state.region.map(region => {
      //   if(region.zg_name === '华北1-天津'){
      //     state.selectedRegionId=region.zg_id;
      //     localStorage.setItem('ai-select-region', region.zg_id);
      //   } 
      // }); 
      if(!state.selectedRegionId){
        let firstRegionId = state.region[0] ? state.region[0].zg_id : '';
        let hasRegion = state.region.some(region => {
          return region.zg_id === localStorageRegionId;
        });
        setRegionId = hasRegion ? localStorageRegionId : firstRegionId;
        state.selectedRegionId = setRegionId;
      }
    } else {
      // state.region.map(region => {
      //   if(region.zg_name === '华北1-天津'){
      //     state.selectedRegionId=region.zg_id;
      //     localStorage.setItem('ai-select-region', region.zg_id);
      //   } 
      // });  
      if(!state.selectedRegionId){
        state.selectedRegionId = state.region[0] ? state.region[0].zg_id : '';
      }
      
    }
    // window.location.reload();
  },

  /**
   * 设置是否展示region下拉框
   */
  [mutationTypes.SET_IS_SHOW_REGION_SELECT](state, isShowRegionSelect) {
    state.isShowRegionSelect = isShowRegionSelect;
  },

  /**
* 设置是否为新建页面
*/
[mutationTypes.SET_IS_CREATE_PAGE](state, isCreatePage) {
  state.isCreatePage = isCreatePage;

  let selector = document.querySelector('#MONO_CONTENT');
  let selectorClass = selector.getAttribute("class");
  if (isCreatePage) {
    if (selectorClass.indexOf('allscreen') <= -1) {
      selectorClass = selectorClass.concat(" allscreen");
    }
  } else {
    selectorClass = selectorClass.replace(/allscreen/g, "");
  }
  selector.setAttribute("class", selectorClass);
},

  /**
   * 设置userInfo
   */
  [mutationTypes.SET_USER_INFO](state, userInfo) {
    state.userInfo = userInfo;
  },

  /**
   * 设置可用余额accountRemainder
   */
  [mutationTypes.SET_ACCOUNT_REMAINDER](state, accountRemainder) {
    state.accountRemainder = accountRemainder;
  },

  /**
   * 设置未读消息messageCount
   */
  [mutationTypes.SET_MESSAGE_COUNT](state, messageCount) {
    state.messageCount = messageCount;
  },

  /**
   * 设置未读消息unreadMessage
   */
  [mutationTypes.SET_UNREAD_MESSAGE](state, message) {
      state.message = message;
  },

  /**
   * 设置待处理工单pendingOrder
   */
  [mutationTypes.SET_PENDING_ORDER](state, pendingOrder) {
      state.pendingOrder = pendingOrder;
  }
}
